import { PropertySellabilityRank } from '../property/types';

export const propertySellabilityRankLabels: Record<PropertySellabilityRank, string> = {
  [PropertySellabilityRank.LOW]: 'Bassa vendibilità',
  [PropertySellabilityRank.MEDIUM]: 'Bassa vendibilità',
  [PropertySellabilityRank.HIGH]: 'Alta vendibilità',
  [PropertySellabilityRank.HIGHEST]: 'Alta vendibilità',
};
